/* eslint-disable react-hooks/exhaustive-deps */
/* ============================================================
   จัดการทะเบียน "ระบบการผลิต" (Hot fill / Cold fill / Retort ...)

   ใช้จากหน้า Finished Goods — เพิ่ม / แก้ไข / ลบ ได้ในตัว
============================================================ */
import { useEffect, useState } from "react";
import { Modal, Table, Input, Button, Space, Flex, Popconfirm, message } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import { RiDeleteBin5Line } from "react-icons/ri";

import ProductionSystemService from "../../../../service/ERP/ProductionSystem.service";

const psService = ProductionSystemService();

export default function ModalProductionSystem({ show, close, onChanged }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [editing, setEditing] = useState(null);

  const load = () => {
    setLoading(true);
    psService
      .list()
      .then((res) => setRows(res.data?.data || []))
      .catch(() => message.error("โหลดรายการระบบการผลิตไม่สำเร็จ"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (show) {
      setName("");
      setEditing(null);
      load();
    }
  }, [show]);

  const handleSave = () => {
    const v = (name || "").trim();
    if (!v) {
      message.error("กรุณากรอกชื่อระบบการผลิต");
      return;
    }
    const req = editing ? psService.update(editing.id, v) : psService.create(v);
    req
      .then((res) => {
        message.success(res.data?.message || "บันทึกเรียบร้อย");
        setName("");
        setEditing(null);
        load();
        if (typeof onChanged === "function") onChanged();
      })
      .catch((err) =>
        message.error(err?.response?.data?.message || "บันทึกไม่สำเร็จ")
      );
  };

  const handleDelete = (rec) => {
    psService
      .deleted(rec.id)
      .then(() => {
        message.success("ลบเรียบร้อย");
        load();
        if (typeof onChanged === "function") onChanged();
      })
      .catch((err) =>
        message.error(err?.response?.data?.message || "ลบไม่สำเร็จ")
      );
  };

  return (
    <Modal
      title="จัดการระบบการผลิต"
      open={show}
      onCancel={() => close(false)}
      footer={null}
      width={560}
      destroyOnClose
    >
      <Space direction="vertical" style={{ display: "flex" }} size="middle">
        <Flex gap={8}>
          <Input
            placeholder="เช่น Hot fill"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onPressEnter={handleSave}
          />
          <Button type="primary" icon={<PlusOutlined />} onClick={handleSave}>
            {editing ? "บันทึก" : "เพิ่ม"}
          </Button>
          {editing && (
            <Button
              onClick={() => {
                setEditing(null);
                setName("");
              }}
            >
              ยกเลิก
            </Button>
          )}
        </Flex>

        <Table
          size="small"
          bordered
          rowKey="id"
          loading={loading}
          dataSource={rows}
          pagination={{ pageSize: 8, showSizeChanger: false }}
          locale={{ emptyText: <span>ยังไม่มีระบบการผลิต</span> }}
          columns={[
            { title: "ระบบการผลิต", dataIndex: "name", key: "name" },
            {
              title: "",
              key: "action",
              width: 100,
              align: "center",
              render: (_, rec) => (
                <Space size={4}>
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => {
                      setEditing(rec);
                      setName(rec.name);
                    }}
                  />
                  <Popconfirm
                    title={`ลบ ${rec.name}?`}
                    okText="ลบ"
                    cancelText="ยกเลิก"
                    onConfirm={() => handleDelete(rec)}
                  >
                    <Button size="small" danger icon={<RiDeleteBin5Line />} />
                  </Popconfirm>
                </Space>
              ),
            },
          ]}
        />
      </Space>
    </Modal>
  );
}
